import Phaser from 'phaser';
import { PLAYER_CONFIG } from '../config';

export class Projectile extends Phaser.Physics.Arcade.Sprite {
  private lifeTimer: number;
  private direction: 1 | -1;
  private dying = false;

  constructor(scene: Phaser.Scene, x: number, y: number, dir: 1 | -1) {
    super(scene, x, y, 'projectile');
    scene.add.existing(this);
    scene.physics.add.existing(this);

    this.direction = dir;
    this.setFlipX(dir < 0);
    this.lifeTimer = PLAYER_CONFIG.spellProjectileLifetime;

    // AI-спрайт ~771×206 → отображаем как 130×35 (горизонтально вытянутый wisp)
    this.setDisplaySize(130, 35);

    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setAllowGravity(false);
    body.setVelocity(dir * PLAYER_CONFIG.spellProjectileSpeed, 0);

    // Лёгкая пульсация (не сбрасываем displaySize-scale, тогда было бы x1.15→x0.16)
    const baseSX = this.scaleX;
    const baseSY = this.scaleY;
    scene.tweens.add({
      targets: this,
      scaleX: baseSX * 1.08,
      scaleY: baseSY * 1.08,
      duration: 120,
      yoyo: true,
      repeat: -1,
    });
  }

  override preUpdate(time: number, delta: number) {
    super.preUpdate(time, delta);
    if (this.dying) return;

    // Bulletproof: каждый кадр насильно прописываем скорость и нулевую гравитацию.
    // Phaser `physics.add.group({allowGravity: false})` похоже применяет конфиг
    // только к телам, созданным через group.create(), а не к существующим телам,
    // добавляемым через group.add() — поэтому без этого хака снаряд начинал падать.
    const body = this.body as Phaser.Physics.Arcade.Body;
    if (body) {
      body.allowGravity = false;
      body.setVelocity(this.direction * PLAYER_CONFIG.spellProjectileSpeed, 0);
    }

    this.lifeTimer -= delta;
    if (this.lifeTimer <= 0) this.kill();
  }

  kill() {
    if (this.dying) return;
    this.dying = true;
    const body = this.body as Phaser.Physics.Arcade.Body;
    if (body) body.setEnable(false);
    this.scene.tweens.killTweensOf(this);
    // Relative-scale tween: scale: 1.4 был бы абсолютным значением, после
    // setDisplaySize sprite.scale ≈ 0.17, то есть 1.4 = 8× → снаряд раздувался
    // на весь экран, желтый flash + лавина physics overlap → freeze.
    this.scene.tweens.add({
      targets: this,
      alpha: 0,
      scaleX: this.scaleX * 1.4,
      scaleY: this.scaleY * 1.4,
      duration: 100,
      onComplete: () => this.destroy(),
    });
  }

  isAlive() {
    return !this.dying && this.active;
  }
}
